<template>
	<path
		id="Vector"
		d="M15.5312 8.5313L10.2812 13.7813C9.8125 14.2501 9 13.9219 9 13.2501V10.2501H4.75C4.33437 10.2501 4 9.91568 4 9.50005V6.50005C4 6.08443 4.33437 5.75005 4.75 5.75005H9V2.75005C9 2.0813 9.80937 1.75005 10.2812 2.2188L15.5312 7.4688C15.8219 7.76255 15.8219 8.23755 15.5312 8.5313ZM6 13.6251V12.3751C6 12.1688 5.83125 12.0001 5.625 12.0001H3C2.44688 12.0001 2 11.5532 2 11.0001V5.00005C2 4.44693 2.44688 4.00005 3 4.00005H5.625C5.83125 4.00005 6 3.8313 6 3.62505V2.37505C6 2.1688 5.83125 2.00005 5.625 2.00005H3C1.34375 2.00005 0 3.3438 0 5.00005V11.0001C0 12.6563 1.34375 14.0001 3 14.0001H5.625C5.83125 14.0001 6 13.8313 6 13.6251Z"
		fill="#E2E2E2"
	/>
</template>
